module.exports = __webpack_public_path__ + "static/img/4areaB_16.cc04115.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/4areaB_16.png
// module id = 1180
// module chunks = 1